import {Button} from "../../../../index";
import React from "react";
import FinaliseConfirm from "./FinaliseConfirm";
import {useViewerStore} from "../../../../../store/store";
import {RoofMesh} from "../../../../../@types/types";

interface SingleModuleAlertProps {
    roofs : RoofMesh[]
}

const SingleModuleValidation = (props: SingleModuleAlertProps) => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const confirmFinalize = () => {
        sceneViewer.viewerAlert({
            show: true,
            title: "Save Design",
            message: <FinaliseConfirm/>,
            messageType: "success",
            isModal: true
        })
    }


    const cancelFinalize = () => {
        sceneViewer.viewerAlert({show: false})
    }


    return (
        <>
            <p>There is a single module on Roof {props.roofs.join(' ,Roof ')}.
                <br/>
                <br/>
                If you wish to continue finalizing the design, click 'Confirm' below. </p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>

                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={confirmFinalize}
                >
                    Confirm
                </Button>
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancelFinalize}
                >
                    Cancel
                </Button>

            </div>
        </>
    )
}

export default SingleModuleValidation;